/**
 * CartToast - Temporary toast notification when item is added/removed.
 * Auto-dismisses after 3 seconds.
 */
export class CartToast {
  constructor(options = {}) {
    this.onUndo = options.onUndo || (() => {});
    this.onHide = options.onHide || (() => {});
    this.element = null;
    this.dismissTimer = null;
  }

  show(product, action = 'added') {
    this.hide(true); /* skipOnHide: we're replacing, don't shrink panel yet */

    const toast = document.createElement('div');
    toast.className = 'ttp-cart-toast';

    toast.innerHTML = `
      <div class="ttp-toast-icon">\u2713</div>
      <div class="ttp-toast-content">
        <div class="ttp-toast-title">Added to cart!</div>
        <div class="ttp-toast-product">${product.name}</div>
      </div>
      <button class="ttp-toast-undo">Undo</button>
    `;

    toast.querySelector('.ttp-toast-undo').addEventListener('click', () => {
      this.onUndo(product);
      this.hide();
    });

    this.element = toast;
    this.dismissTimer = setTimeout(() => this.hide(), 3000);

    return toast;
  }

  /**
   * @param {boolean} [skipOnHide] - When true, do not invoke onHide. Use when clearing to show a new toast.
   */
  hide(skipOnHide = false) {
    if (this.dismissTimer) {
      clearTimeout(this.dismissTimer);
      this.dismissTimer = null;
    }
    if (this.element && this.element.parentNode) {
      this.element.classList.add('ttp-toast-hiding');
      const el = this.element;
      this.element = null;
      const invokeOnHide = !skipOnHide;
      setTimeout(() => {
        if (el && el.parentNode) {
          el.parentNode.removeChild(el);
        }
        if (invokeOnHide) this.onHide();
      }, 300);
    }
  }
}
